export var errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map